import React from 'react'
import { GROUPTILES, PRODUCTTILES } from "../../constants/rootElements";
import CatalogBrowseGroupTiles from './catalogBrowseGroupTiles'
import { CatalogBrowseProductTiles } from './catalogBrowseProductTiles'

const HomePage = ({ appData }) => {
	const ShowGroupTiles = Boolean(appData.pageContentData?.find(data => data.contentType === "catalogBrowseGroupTiles"))
	const ShowProductTiles = Boolean(appData.pageContentData?.find(data => data.contentType === "catalogBrowseProducts"))
	

	const groupTiles = () => {
		GROUPTILES.render(<CatalogBrowseGroupTiles appData={appData} />);
	}

	const productTiles = () => {
		PRODUCTTILES.render(<CatalogBrowseProductTiles appData={appData} />);	
	}

	return (
		<div id="catalog-browse" className="container-fluid">
			{ShowGroupTiles && groupTiles()}
			{ShowProductTiles && productTiles()}
		</div>
	)
}
export default HomePage;